import { render, staticRenderFns } from "./LocationPopup.vue?vue&type=template&id=54a921f3&"
import script from "./LocationPopup.vue?vue&type=script&lang=js&"
export * from "./LocationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports